var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEex = function SvgIconEex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#222",
    clipPath: "url(#icon_EEX_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.334 0H1.666a.833.833 0 0 0-.834.833v18.334c0 .46.373.833.834.833h16.667c.46 0 .833-.373.833-.833V.833A.833.833 0 0 0 18.333 0m0 19.167H1.666V.833h16.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.334 16.667h.833v-2.5h1.667v2.5h.833v-3.334H8.334zM7.5 15.833H5v-1.666h2.5v-.834H4.167v3.334H7.5zM12.5 14.167H15v1.666h-2.5v.834h3.334v-3.334H12.5zM12.917 10.833V8.75h-.833V10H8.75V7.5h2.084v-.833H8.75v-2.5h3.334v1.25h.833V3.333h-6.25v.834h1.25V10h-1.25v.833z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_EEX_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconEex;